<template>
  <el-table
    :data="list"
    style="width: 100%; margin-top: 30px"
    @selection-change="handleSelectionChange"
  >
    <el-table-column fixed type="selection" width="55" align="center" />
    <el-table-column sortable prop="id" label="ID" width="80" align="center" />
    <el-table-column prop="image" label="主图" width="80" align="center">
      <template slot-scope="{ row }">
        　<img :src="row.img + '?x-oss-process=image/resize,w_60,h_60'" />
      </template>
    </el-table-column>
    <el-table-column prop="name" label="名称" align="center" width="300" />
    <el-table-column prop="is_diy" label="定制" align="center">
      <template slot-scope="{ row }">
        <div v-if="row.is_diy == 1">可定制</div>
        <div v-if="row.is_diy == 0">不可定制</div>
        <div v-if="row.is_diy == 2">自动</div>
        <div v-if="row.is_diy == 3">固定文字</div>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="排序" align="center" width="80">
      <template slot-scope="{ row }">
        <el-input
          v-model="row.sort"
          @change="changeSort($event, row)"
        ></el-input>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="状态" align="center">
      <template slot-scope="{ row }">
        <el-switch
          v-model="row.status"
          :active-value="1"
          :inactive-value="0"
          @change="switchStatus($event, row)"
        />
      </template>
    </el-table-column>
    <el-table-column prop="create_time" label="创建时间" align="center">
      <template slot-scope="{ row }">
        <span>{{ parseTime(row.create_time, "{y}-{m}-{d} {h}:{i}") }}</span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="{ row }">
        <el-button type="text" @click="handleEdit(row)">编辑</el-button>
        <el-button type="text" @click="handleDel(row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default class DesignFace extends Vue {}
</script>
